import { showInfoToast } from 'lib/ToastHelper';
import React from 'react';

import styles from './styles.module.css';

interface CopyToClipboardWrapperProps {
  valueToCopy: string;
  children: React.ReactNode;
  iconPosition?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
}

const CopyToClipboardWrapper: React.FC<CopyToClipboardWrapperProps> = ({
  valueToCopy,
  children,
  iconPosition = 'top-right',
}) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(valueToCopy);
    showInfoToast('Copied to clipboard');
  };

  return (
    <div className={styles.copyToClipboardWrapper}>
      <div
        className={`${styles.copyIcon} ${styles[iconPosition]}`}
        onClick={handleCopy}
      >
        <i className="fa fa-copy fa-lg"></i>
      </div>
      {children}
    </div>
  );
};

export default CopyToClipboardWrapper;
